import type { BaseState, ServiceAppState } from '@kc-console/context';
import type { Guard } from '../../../types';

/**
 * Onboarding 에서 서버사이드 초기 진입 시 호출되는 가드
 * @description
 * 로그인 기반 화면 — 토큰 검증은 generateBaseTokenGuard에서 수행
 * 추후 커스텀 에러 정의, 리다이렉트 로직 등 확장 시 이 가드에 추가
 *
 * ℹ️ Account의 accountInitialGuard는 generateInitialServerSideGuards의 가드 체인에 포함되지 않고
 * index.ts에서 별도 export만 됩니다. Onboarding은 추후 확장 가능성을 고려하여
 * 가드 체인에 직접 포함하는 방식을 채택했습니다 (Account와 의도적 차이).
 */
export const onboardingInitialGuard: Guard<ServiceAppState & BaseState> = async ({ state }) => {
  const { status } = state;
  return { status };
};

onboardingInitialGuard.displayName = 'onboardingInitialGuard';
